import axios from "axios";
import { base_url } from "../../Utils/baseUrl";
import { config } from '../../Utils/axiosconfig';

const getfavourites = async (data, userId) => {
    const response = await axios.get(`${base_url}favouriteorders/getFavourites/${userId}?pageSize=${data?.pageSize}&pageNumber=${data?.pageNumber}`, config);
    return response?.data?.data;
};

const setFavorite = async (data) => {
    try {
        const response = await axios.post(`${base_url}favouriteorders/addFavourite`, data, config);
        return response;

    } catch (error) {
        return error?.response || error;
    }
}

const removeFavourite = async (data) => {
    const headers = { ...config }

    const response = await axios.post(`${base_url}favouriteorders/addFavourite`, data, headers);
    return response.data;
};


const FavouriteService = {
    getfavourites,
    setFavorite,
    removeFavourite,
};

export default FavouriteService;